<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>
      <template>
        <div style="display:table">
          <div style="display: table-cell;vertical-align: middle;">
            <a href="javascript:void(0)" style="color:#000000" @click="back()"
              >Campaign ></a
            >
            <span style="font-weight:bold;padding-left:5px;">{{
              campName
            }}</span>
          </div>
        </div>
        <div class="adv_fil_wrap">
          <FilterCamp @makeKeywordCallFromAdvFilters='makeKeywordCallFromAdvFilters' />
        </div>

        <div>
          <div class="head_search">
            <object
              data="assets/img/search.svg"
              style="height: 18px; width: 18px; margin-left: 5px"
            ></object>
          </div>
          <div class="ghost" @click="getFilterProducts()"></div>
          <div class="head_search_inp">
            <input
              type="search"
              class="search"
              id="search"
              v-model="searchFilterString"
              :placeholder="
                ($route.params.sponsoredType || '') == 'sd' ? 'ASIN' : 'Keyword'
              "
              @keyup.enter="getFilterProducts()"
              autocomplete="off"
              style="border: none; outline: none; padding: 7px 0px 5px 10px"
            />
          </div>
        </div>
      </template>
    </template>
  </CommonHeader>
</template>

<script>
import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue";
import FilterCamp from "@/components/keyword/KeyAdvFilters.vue";

export default {
  name: "KeywordFilters",
  data() {
    return {
      tagsList: [],
      selectedTag: [],
    };
  },
  components: {
    Multiselect,
    CommonHeader,
    FilterCamp
  },
  props: ["campName"],
  computed: {
    searchFilterString: {
      set(val) {
        if (!val) {
          this.$store.state.searchKeywordFilterString = val;
          this.$emit("showPerPageChanged");
        } else {
          this.$store.state.searchKeywordFilterString = val;
        }
      },
      get() {
        return this.$store.state.searchKeywordFilterString;
      },
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    makeKeywordCallFromAdvFilters(data){
      this.$emit("fetchKeywordCallFromAdvFilters",data)
    },
    back() {
      this.$emit("getBackToCampaignList");
    },
    getData() {
      let vm = this;
      this.$store
        .dispatch("campaign/getTagsForKeyword", {
          type: this.$route.params.sponsoredType == "sd" ? "asin" : "keyword",
        })
        .then((data) => {
          if (data && data.length && data[0].id != "all")
            data.unshift({ id: "all", title: "All Tags" });
          vm.tagsList = data;
        });
    },
    resetFooter() {
      sessionStorage.setItem("keyword:keywordShowPerPage", 25);
      this.$store.state.keywordCurrentPageNumber = 1;
      this.$store.state.keywordShowPerPage = 25;
      this.$store.state.totalKeywordCount = 0;
      this.$store.state.campaign.keyWordToTagList = [];
      this.$store.state.campaign.actionSelectionControl = false;
    },
    getFilterProducts() {
      this.resetFooter();
      this.$emit("showPerPageChanged");
    },
    selectTag(data) {
      if (data.id == "all") {
        this.$emit("showPerPageChanged");
      } else {
        this.$emit("getKeywordForTagsList", data);
      }
    },
    resetFilter() {
      this.selectedTag = [];
      this.$emit("showPerPageChanged");
    },
  },
};
</script>

<style lang="scss"></style>
